<template>
  <v-container>
    <plan-gate service="agents" />
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"
    ></loading>
    <v-alert v-if="error" :value="true" color="error">
      {{ error }}
    </v-alert>
    <v-card>
      <v-card-title class="text-center mb-0 pb-0">
        <h2 class="mx-auto">{{ $t('agents.adding_agent') }}
          <br v-if="seatLimit > 0"><span v-if="seatLimit > 0" class="text-subtitle-1"><span :class="seatCount >= seatLimit ? 'error--text' : ''">{{ seatCount }}</span>/{{ seatLimit }}</span>
        </h2>
      </v-card-title>

      <SeatLimitDialog
        v-model="seatPaywall.show"
        :info="seatPaywall.info"
        :busy="seatPaywall.busy"
        @buy="buyExtraUser(signup, $event)"
        @to-tariff="seatPaywallToTariff"
      />

      <v-card-text>
        <v-container grid-list-md>
          <v-row justify="center" align="center" wrap>
            <v-flex xs12 sm12 md4> </v-flex>
          </v-row>
          <v-row justify="center" align="center" wrap>
            <v-flex xs12 sm12 md4 class="justify-center">
              <v-text-field
                v-model="user_name"
                :label="$t('employers.nickname') + ' *'"
                data-testid="agent-nickname-field"
                required
              ></v-text-field>
              <v-text-field
                v-model="first_name"
                :label="$t('employers.name') + ' *'"
                data-testid="agent-first-name-field"
                required
              ></v-text-field>
              <v-text-field
                v-model="middle_name"
                :label="$t('employers.middle_name')"
                data-testid="agent-middle-name-field"
                required
              ></v-text-field>
              <v-text-field
                v-model="last_name"
                :label="$t('employers.last_name') + ' *'"
                data-testid="agent-last-name-field"
                required
              ></v-text-field>
              <v-text-field
                v-model="phone"
                :label="$t('employers.phone') + ' *'"
                data-testid="agent-phone-field"
                required
              ></v-text-field>
              <v-text-field
                v-model="email"
                :label="$t('employers.email') + ' *'"
                data-testid="agent-email-field"
                required
              ></v-text-field>
              <v-flex class="text-center">
                <v-btn
                  v-if="checkAdminManager()"
                  @click="signup()"
                  color="success"
                  data-testid="agent-create-btn"
                  >{{ $t('agents.create_agent') }}</v-btn
                >
              </v-flex>
              <v-flex class="text-center mt-3">
                {{ $t('agents.after_save_email') }}
              </v-flex>
            </v-flex>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import moment from "moment";
import seatPaywall from "@/mixins/seatPaywall";
import SeatLimitDialog from "@/components/common/SeatLimitDialog.vue";
export default {
  mixins: [seatPaywall],
  components: { SeatLimitDialog },
  data: () => ({
    user: [],
    user_name: null,
    first_name: null,
    middle_name: null,
    last_name: null,
    phone: null,
    email: null,
    show1: false,
    isLoading: false,
    isLoadingSubscribeToPaidTariff: false,
    error: ""
  }),
  created() {
    if (this.$store.getters.isLoggedIn) {
      if (!this.$store.getters.isSuperAdmin && !this.$store.getters.isAdmin && !this.$store.getters.isManager) {
        this.goBack();
        this.$notify(this.$t('errors.not_permitted_title'), this.$t('errors.only_admins_2'), "error", 3000);
      }
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  computed: {
    // FT-077: эффективный лимит мест (Plan.users_limit + extra_user). Fallback на plan.users_limit
    // для совместимости в окно деплоя.
    seatLimit() {
      const mc = this.$store.getters.getMainCompany;
      if (!mc) return 0;
      if (mc.effective_users_limit != null) return mc.effective_users_limit;
      return (mc.plan && mc.plan.users_limit) || 0;
    },
    seatCount() {
      const mc = this.$store.getters.getMainCompany;
      return (mc && mc.active_users_count) || 0;
    },
    userMustChangeTariffPlan() {
      if (this.$store.getters.getMainCompany) {
        if (this.$store.getters.getMainCompany.plan && this.$store.getters.getMainCompany.plan.id) {
          if(this.$store.getters.getMainCompany.plan.name == "Старт" || this.$store.getters.getMainCompany.plan.name == "Start") {
            if(this.$store.getters.getMainCompany.plan.trial_end && moment(this.$store.getters.getMainCompany.plan.trial_end).isAfter(moment())) {
              return false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        } else {
          return false
        }
      } else {
        return false;
      }
    },
  },
  methods: {
    async signup() {
      // проверяем на должника
      if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.payer_state == 3) {
        this.$notify(this.$t("errors.payer_state_3_title"), this.$t("errors.payer_state_3_text"), "warning", 10000);
        return;
      }
      if (!(this.email && this.user_name && this.first_name && this.last_name && this.phone)) {
        this.$notify(this.$t('errors.all_fields_title'), this.$t('errors.all_fields_text'), "error", 5000);
        return;
      }
      // FT-077: soft-чек убран — лимит мест энфорсит бэкенд (422 user_limit_reached),
      // пейвол открывается из .catch (вкл. цену доп.места), ретрай после покупки.
      let self = this;
      this.isLoading = true;
      try {
        this.axios
          .post(
            "/create_agent",
            {
              users: {
                name: self.user_name,
                first_name: self.first_name,
                middle_name: self.middle_name,
                last_name: self.last_name,
                phone: self.phone,
                email: self.email,
                role: "agent",
              },
            },
            { headers: { Authorization: this.$store.getters.getAuthToken } }
          )
          .then((response) => {
            // POST /create_agent отвечает 204 БЕЗ ТЕЛА, когда создание
            // откатилось: SignupController#create_agent ловит StandardError
            // внутри транзакции, пишет его в лог и делает
            // ActiveRecord::Rollback — рендера при этом не происходит, и Rails
            // отдаёт head :no_content. Для axios это успешный ответ.
            //
            // Прод 2026-08-26, 09:56:32 и 09:57:12 (два раза подряд с одного
            // адреса, YaBrowser/macOS): агента не создали («Error: Возникли
            // ошибки: Email уже существует» в логе бэкенда), а фронт брал
            // response.data.id из пустого тела, показывал «Агент добавлен!» и
            // уходил на `/agents/undefined`. Оттуда карточка агента дёргала
            // GET /admin/users/undefined -> 404.
            //
            // Нет id — значит агента нет, чем бы ни был вызван откат.
            const agentId = response && response.data && response.data.id;
            if (!agentId) {
              this.$notify(
                this.$t('errors.employer_add'),
                this.$t('errors.something_went_wrong'),
                "error",
                6000
              );
              return;
            }
            this.$router.replace(`/agents/${agentId}`);
            this.$notify(this.$t('agents.added_agent'), "", "success", 3000);
          })
          .catch(error => {
            if (this.maybeSeatPaywall(error)) return;
            this.setError(error, this.$t('errors.employer_add'));
          })
          .finally(() => {
            this.isLoading = false;
          });
      } catch (error) {
        this.isLoading = false;
        this.setError(error, this.$t('errors.error'));
        console.log(error);
      }
    },
    currentUser() {
      return this.$store.getters.getCurrentUser;
    },
    checkAdminManager() {
      return this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin || this.$store.getters.isManager;
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        var fpath = this.PageData.backCrumb.url;
        this.$router
          .push({
            path: fpath
          })
          .catch(err => {});
      }
    },
  }
};
</script>
